import { render, staticRenderFns } from "./exhibition-template-new-service.vue?vue&type=template&id=fe5ec1e8&scoped=true&"
import script from "./exhibition-template-new-service.vue?vue&type=script&lang=js&"
export * from "./exhibition-template-new-service.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-template-new-service.vue?vue&type=style&index=0&id=fe5ec1e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5ec1e8",
  null
  
)

export default component.exports